const downloadFileFromUrl = async (fileUrl) => {
  const { headers, url } = fileUrl;

  const rsp = await fetch(url, { headers });
  return rsp.arrayBuffer();
};

export default downloadFileFromUrl;
